/** cast HTMLElement.attributes to Svelte component props */
export const attrs2props = <R extends Record<string, unknown>>(attrs: Element["attributes"]) =>
  Object.fromEntries(Array.from(attrs, ({ name, value }) => [camelCase(name), value])) as R

/** "foo-bar-baz" -> "fooBarBaz" */
const camelCase = (str: string) => str.replace(/-(\w)/g, (_, c) => c.toUpperCase())
